var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1906 0.229211C18.6536 -0.0762753 17.9796 -0.0763124 17.4425 0.229115L11.334 3.70314C10.5146 4.1691 9.48642 4.16912 8.66709 3.7032L2.55764 0.229028C2.02062 -0.076356 1.34667 -0.0763413 0.80966 0.229066C-0.269908 0.843032 -0.269882 2.31013 0.809708 2.92407L8.66703 7.39231C9.48639 7.85826 10.5147 7.85823 11.334 7.39223L19.1905 2.92381C20.2698 2.30994 20.2699 0.843174 19.1906 0.229211Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1906 6.35812C18.6536 6.05263 17.9796 6.05259 17.4425 6.35802L11.334 9.83205C10.5146 10.298 9.48642 10.298 8.66709 9.83211L2.55764 6.35793C2.02062 6.05255 1.34667 6.05256 0.80966 6.35797C-0.269908 6.97194 -0.269882 8.43904 0.809708 9.05297L8.66703 13.5212C9.48639 13.9872 10.5147 13.9871 11.334 13.5211L19.1905 9.05272C20.2698 8.43884 20.2699 6.97208 19.1906 6.35812Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1906 12.487C18.6536 12.1815 17.9796 12.1815 17.4425 12.4869L11.334 15.961C10.5146 16.4269 9.48642 16.4269 8.66709 15.961L2.55764 12.4868C2.02062 12.1815 1.34667 12.1815 0.80966 12.4869C-0.269908 13.1008 -0.269882 14.5679 0.809708 15.1819L8.66703 19.6501C9.48639 20.1161 10.5147 20.116 11.334 19.65L19.1905 15.1816C20.2698 14.5677 20.2699 13.101 19.1906 12.487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsDown);
export default __webpack_public_path__ + "static/media/arrowsDown.ec0e3f974348fc89ae76579d8d8805ab.svg";
export { ForwardRef as ReactComponent };